import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { callMsGraph } from "../../../graph";

import RhinoLoading from '../common/RhinoLoading';


export const ProfileLoading = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);

    useEffect(() => {
	    RequestProfileData();
	  }, []);

    function RequestProfileData() {

      // instance.acquireTokenSilent({
      //     ...loginRequest,
      //     account: accounts[0]
      // }).then((response) => {

      //     callMsGraph(response.accessToken)
      //   	.then(response => {

      //   		setGraphData(response)
      //   	});
      // }).catch((err) => {
      // 	console.error(err);
      // });
    }

    return (
        <>
            {false ? 
                <div></div> :
                <RhinoLoading />
            }
        </>
    );
};


export const LoginRedirect = () => {

    // const { instance } = useMsal();
    useEffect(() => {
	    ProfileLoading();
	  }, []);

    return (
    	<div className='Login'>
	      <div className='formBodyWrapper'>
	        <div className='loginTitle'>Employee Login</div>
	        <div className='loginBr'>
	          <img src='/img/manageusers/iconline_thinlight2.svg' />
	        </div>
	        
	        <div className='ResponsiveForm'>
	          
	          
	          <div className='formRow' style={{ marginTop: '50px', textAlign: 'center', fontSize: '24px', fontWeight: '300'}}>
	            <div className='formCopy'>
	              Completing Login
	            </div>
	          </div>
	          <div className='formRow'>
	            <ProfileLoading />
	          </div>
	          
	        </div>
	      </div>
	    </div>
    );
}